package team.platforma.multiplatform_material_extension.calendar.properties

class DatePikerProperties(
    val animateUserScroll: Boolean = false,
    var animateClickChangeButtonMonth : Boolean = false,
    var dismissOnBackPress: Boolean = true,
    var dismissOnClickOutside: Boolean = true,
)
